import React from 'react';

interface PhoneFrameProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Cadre « téléphone » réutilisable (bezel + écran à l'aspect-ratio d'un iPhone).
 * Extrait de HeroCarousel pour être partagé avec la carte du commentaire du jour.
 */
const PhoneFrame: React.FC<PhoneFrameProps> = ({ children, className, style }) => (
  <div className={`relative w-[230px] ${className ?? ''}`} style={style}>
    <div className="bg-amber-900 rounded-[2rem] p-2 shadow-xl">
      <div className="bg-amber-100 rounded-[1.666rem] overflow-hidden aspect-[1290/2796]">
        {children}
      </div>
    </div>
  </div>
);

export default PhoneFrame;
